import { gql, TypedDocumentNode } from '@apollo/client'

import { Data, Variables } from './types'

export const GET_WORKSPACE_BIDDERS: TypedDocumentNode<Data, Variables> = gql`
  query getWorkspaceBidders(
    $first: Int
    $last: Int
    $sort: WorkspaceBidderSortInput
    $terms: [String!]
    $workspaceId: ID!
  ) {
    workspaceBidders(
      first: $first
      last: $last
      sort: $sort
      terms: $terms
      workspaceId: $workspaceId
    ) {
      nodes {
        accountType
        bidCpmAdjustment
        bidder {
          name
          code
        }
        bidderCode
        consentMode
        enabled
        id
        priority
        supplyChain {
          name
        }
        status
      }

      totalCount
    }
  }
`
